import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { siteData } from '../../data/content';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus } = FiIcons;

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 bg-slate-900 border-b border-slate-800">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-blue-500 font-bold tracking-widest uppercase text-xs mb-3 block">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight">
            Common Questions
          </h2>
        </div>

        <div className="space-y-3">
          {siteData.faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="bg-slate-950 border border-slate-800 rounded-sm overflow-hidden"
            >
              <button
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none group"
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <span className="font-bold text-white pr-8 text-sm leading-relaxed group-hover:text-blue-400 transition-colors">
                  {faq.q}
                </span>
                {openIndex === index
                  ? <FiMinus className="text-blue-500 flex-shrink-0" />
                  : <FiPlus className="text-blue-500 flex-shrink-0" />
                }
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-60 pb-5 opacity-100' : 'max-h-0 opacity-0'}`}>
                <p className="text-slate-400 text-sm leading-relaxed border-t border-slate-800 pt-4">{faq.a}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}